<script>
import axios from 'axios'
export default {

    layout: 'layout-guest',

    methods:
    {
        login()
        {
            this.$api('post', '/v1/admin/auth/login', this.auth, {
                title: '',
                body: this.$t('USER.LOGGINGIN'),
                success: this.$t('USER.LOGGEDIN'),
            }).then((auth) => {
                if (auth.role == 100)
                {
                    this.$store.dispatch('authLogin', auth)
                    this.$router.replace(localStorage.getItem('previousRoute') || '/')
                }
            }).catch((e) => {})
        },
    },

    data()
    {
        return {
            auth: {
                email: null,
                password: null,
            }
        }

    },

}
</script>

<template>
<div class="container">
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel panel-primary">
                <div class="panel-heading">
                    Login
                </div>

                <div class="panel-body">
                    <form class="form-horizontal" role="form" @submit.prevent.stop="login">
                        <div class="form-group">
                            <label for="email" class="col-md-4 control-label">{{ $t('USER.EMAIL') }}</label>

                            <div class="col-md-6">
                                <input type="email" name="email" class="form-control" v-model="auth.email" required autofocus>

                                <span class="help-block">
                                    <strong></strong>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="password" class="col-md-4 control-label">{{ $t('USER.PASSWORD') }}</label>

                            <div class="col-md-6">
                                <input type="password" name="password" class="form-control" v-model="auth.password" required>

                                <span class="help-block">
                                    <strong></strong>
                                </span>
                            </div>
                        </div>

                       <div class="form-group">
                            <div class="col-md-8 col-md-offset-4">
                                <button type="submit" class="btn btn-primary">
                                    {{ $t('USER.LOGIN') }}
                                </button>
                            </div>
                       </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


// WEBPACK FOOTER //
// src/pages/Login.vue